import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'ordinalDate'
})
export class OrdinalDatePipe implements PipeTransform {

  transform(value: Date): string {
    let _date
    if (!value) {
      return ''
    } else {
      _date = new Date(value)
    }
    let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul",
      "Aug", "Sep", "Oct", "Nov", "Dec"]
    return `${months[_date.getMonth()]} ${_date.getDate()}${this.nth(_date.getDate)} ${_date.getFullYear()}`
  }

  nth(d) {
    if (d > 3 && d < 21) return 'th'
    switch (d % 10) {
      case 1: return "st"
      case 2: return "nd"
      case 3: return "rd"
      default: return "th"
    }
  }
}
